import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    redirect: String
  }

  schedule() {
    // Track the meeting request
    this.trackMeetingRequest()

    // Open meeting link in new tab
    window.open(this.urlValue, '_blank')

    // Update button state
    this.updateButtonState()

    // Redirect after delay
    setTimeout(() => {
      if (window.Turbo) {
        window.Turbo.visit(this.redirectValue)
      } else {
        window.location.href = this.redirectValue
      }
    }, 1500)
  }

  trackMeetingRequest() {
    // Google Analytics tracking
    if (window.gtag) {
      window.gtag('event', 'eol_renewal_meeting_requested', {
        event_category: 'engagement',
        event_label: 'EOL Renewal Meeting'
      })
    }

    // Backend tracking (optional)
    fetch('/analytics/track', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({
        event: 'eol renewal meeting requested',
        page: 'eol_renewals'
      })
    }).catch(() => {
      // Silently handle tracking errors
    })
  }

  updateButtonState() {
    const button = this.element

    // Change button appearance
    button.className = button.className.replace('bg-divider', 'bg-green-600')
    button.innerHTML = `
      <div class="text-sm font-medium text-white">
        Meeting opened! Redirecting...
      </div>
    `

    // Disable button
    button.disabled = true

    // Show notification
    this.showNotification()
  }

  showNotification() {
    const notification = document.createElement('div')
    notification.className = 'fixed top-4 right-4 z-50 px-4 py-2 text-white bg-green-600 rounded-lg shadow-lg'
    notification.innerHTML = `
      <div class="flex gap-2 items-center">
        <span>Meeting link opened!</span>
        <button onclick="window.location.href='${this.redirectValue}'"
                class="px-2 py-1 ml-2 text-sm bg-green-700 rounded">
          Go to Dashboard
        </button>
      </div>
    `

    document.body.appendChild(notification)

    // Remove notification after redirect
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification)
      }
    }, 2000)
  }
}
